import type { FormValues } from '../../types';
import { InputIDs } from '../../types';

/**
 * Fields that are used in the form
 */
export const initialFieldValues: FormValues = {
  [InputIDs.EMAIL]: '',
};

/**
 * Fields that should be prefilled with user's data
 */
export const toPrefill = [InputIDs.EMAIL];

/* Reference of Post Body:
  ------------------------------------------------------
  {
    "emailAddress": "mymail@example.com",
    "areaKey": "slideinPromotionFooter",
  }
  */
export const convertFormDataToPostData = (formValues: FormValues) => ({
  emailAddress: formValues[InputIDs.EMAIL] || '',
  areaKey: 'slideinPromotionFooter',
});

/* Reference of Post Body:
  ------------------------------------------------------
  {
    "emailAddress": "mymail@example.com",
    "areaKey": "doiPendingLayer",
  }
  */
export const convertFormDataToPostDataDoiNotification = (formValues: FormValues) => ({
  emailAddress: formValues[InputIDs.EMAIL] || '',
  areaKey: 'doiPendingLayer',
});
